// extracted by mini-css-extract-plugin
export default {"message_time":"styles_message_time__8Of+e"};